import { jsx as _jsx } from "react/jsx-runtime";
import { Navigate } from 'react-router-dom';
import { useAuth } from './auth';
import { tokenService } from './auth/tokenService';
import AuthLoadingScreen from './components/AuthLoadingScreen';
export const PrivateRoute = ({ component: Component, }) => {
    const { isAuthenticated, isLoading, loadingPhase } = useAuth();
    // Session hint = "user logged in earlier this browser session". Its
    // presence means a refresh-token cookie probably exists, so we can
    // optimistically render the protected page and let the axios layer
    // queue API calls behind the in-flight /auth/refresh.
    const hasSessionHint = tokenService.hasSessionHint();
    if (isLoading && !hasSessionHint) {
        // First-time login (no prior session) — full-screen branded loader
        // while MSAL + token exchange complete. There is no page content
        // we could render in the meantime.
        return _jsx(AuthLoadingScreen, { phase: loadingPhase });
    }
    // Redirect to login if not authenticated. This will only fire after
    // the silent refresh has resolved (or failed); during the in-flight
    // window `isAuthenticated` stays at its previous value, so we won't
    // bounce the user away while a normal page-refresh restore is running.
    if (!isLoading && !isAuthenticated) {
        return _jsx(Navigate, { to: "/login", replace: true });
    }
    // Render the protected component immediately. On a page-refresh
    // restore this means the user sees the familiar app shell right away;
    // any data fetches the page kicks off will queue behind the in-flight
    // /auth/refresh in the axios interceptor and resolve once the new
    // access token lands.
    return _jsx(Component, {});
};
